<h1 mat-dialog-title>
  <mat-icon
    class="dialog-header-icon"
    svgIcon="open_project"
  ></mat-icon>
  <span>{{T.F.OPEN_PROJECT.DIALOG_INITIAL.TITLE|translate}}</span>
</h1>

<form
  (submit)="saveOpenProjectCfg(openProjectCfg)"
  [formGroup]="formGroup"
>
  <mat-dialog-content>
    <formly-form
      (modelChange)="openProjectCfg=$event"
      [fields]="formConfig"
      [form]="formGroup"
      [model]="openProjectCfg"
    >
    </formly-form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      (click)="close()"
      color="primary"
      mat-button
      type="button"
    >
      {{T.G.CANCEL|translate}}
    </button>

    <button
      [disabled]="!formGroup.valid"
      color="primary"
      mat-stroked-button
      type="submit"
    >
      <mat-icon>save</mat-icon>
      {{T.G.SAVE|translate}}
    </button>
  </mat-dialog-actions>
</form>
